import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 6rem 2rem 4rem; // 增加顶部padding，给navbar留空间
  font-family: ${theme.fonts.main};
  background: ${theme.colors.background};
  min-height: 100vh;
  
  @media (max-width: 768px) {
    padding: 5rem 1rem 4rem; // 移动端减少左右padding
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

export const Content = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  
  @media (max-width: 768px) {
    padding: 1.5rem; // 移动端减少内边距
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: ${theme.colors.text};
  text-align: center;
  margin-bottom: 2.5rem;
  font-weight: 400;
`;

export const RequirementsSection = styled.div`
  margin: 2.5rem 0;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${theme.colors.primary};
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  color: ${theme.colors.text};
  margin-bottom: 1.5rem;
`;

export const RequirementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const RequirementItem = styled.li`
  display: flex;
  align-items: flex-start;
  font-size: 1.1rem;
  line-height: 1.7;
  color: ${theme.colors.text};
  margin-bottom: 1rem;
  padding: 0.5rem 0;
`;

export const BulletPoint = styled.span`
  color: ${theme.colors.primary};
  font-weight: bold;
  font-size: 1.2rem;
  margin-right: 1rem;
  margin-top: 0.1rem;
`;

export const ContactSection = styled.div`
  text-align: center;
  margin: 3rem 0 2rem;
  padding: 2rem;
  background: #f8f9ff;
  border-radius: 8px;
  border: 1px solid #e8eaff;
`;

export const EmailLabel = styled.p`
  font-size: 1.1rem;
  color: ${theme.colors.text};
  margin-bottom: 1.5rem;
  font-weight: 500;
`;

export const EmailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.8rem;
    width: 100%;
    align-items: stretch; // 让子元素填满宽度
  }
`;

export const EmailLink = styled.a`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${theme.colors.primary};
  text-decoration: none;
  padding: 0.8rem 1.5rem;
  border: 2px solid ${theme.colors.primary};
  border-radius: 8px;
  display: inline-block;
  transition: all 0.3s ease;
  text-align: center;
  
  &:hover {
    background: ${theme.colors.primary};
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(57, 73, 171, 0.3);
  }
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 0.8rem 1rem;
    width: 100%;
    box-sizing: border-box;
    word-break: break-all; // 长邮箱地址可以换行
  }
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 1rem;
  border: 2px solid ${props => props.copied ? '#10b981' : '#6b7280'};
  border-radius: 8px;
  background: ${props => props.copied ? '#f0fdf4' : 'white'};
  color: ${props => props.copied ? '#10b981' : '#6b7280'};
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.copied ? '#dcfce7' : '#f9fafb'};
    border-color: ${props => props.copied ? '#059669' : '#4b5563'};
    color: ${props => props.copied ? '#059669' : '#4b5563'};
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    box-sizing: border-box;
    padding: 0.8rem;
  }
`;

export const CopyIcon = styled.span`
  font-size: 1.1rem;
  transition: all 0.3s ease;
  transform: ${props => props.copied ? 'scale(1.1)' : 'scale(1)'};
`;

export const CopyText = styled.span`
  font-size: 0.9rem;
  font-weight: 500;
`;

export const ClosingText = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.text};
  text-align: center;
  font-weight: 500;
  font-style: italic;
  margin-top: 2rem;
`;